$(document).on('click', '[data-share-item]', function (event) {
  event.preventDefault();
  $.ajax({
    method: 'GET',
    url: $(this).attr('href'),
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('submit', '[data-item-share-form]', function (event) {
  event.preventDefault();
  const $form = $(this);
  const $reveal = $form.closest('[data-reveal]');
  $reveal.addClass('loading');
  $('[data-item-share-reveal] [data-item-share-form] button[type="submit"]').prop('disabled', 'disabled');

  $.ajax({
    method: 'POST',
    url: $form.attr('action'),
    data: $form.serialize(),
  }).then(() => {
    $reveal.removeClass('loading').addClass('loaded');
    document.location.reload();
  });
});

$(document).on('submit', '[data-item-share-user-search]', function (event) {
  event.preventDefault();
  const $form = $(this);
  const $reveal = $form.closest('[data-reveal]');
  $('[data-item-share-reveal] [data-item-share-form] button[type="submit"]').prop('disabled', 'disabled');
  $reveal.addClass('loading');

  $.ajax({
    method: 'GET',
    url: $form.attr('action'),
    data: $form.serialize(),
  }).then((html) => {
    $reveal.find('[data-item-share-search-result]').html(html);
    $reveal.removeClass('loading');
  });
});

$(document).on('change', '[form="item-share-form"]', (event) => {
  const btn = $('[data-item-share-reveal] [data-item-share-form] button[type="submit"]');
  btn.prop('disabled', event.target.checked ? '' : 'disabled');
});
